import {
  VehiclePartial,
  VehicleDetail,
  Status,
  VehicleDocument,
  Prestation,
  VehicleInformation,
  VehiclePricing,
  VehicleAuction,
  Location,
  VehicleVendorInformation,
  defaultVehiclePartial,
  defaultVehicleDetail,
  defaultVehicleInformation,
  defaultVehiclePricing,
  defaultVehicleAuction,
  defaultStatus,
  defaultVehicleVendorInformation,
} from '../subtypes'
import { PaginatedResult } from '../../pagination'

type Vehicle = {
  // OK
  no: string
  entityId: string
  contactId: string | null
  vehiclePartial: VehiclePartial
  vehicleDetail: VehicleDetail
  status: Status
  documents: Array<VehicleDocument> | null
  photos: Array<VehicleDocument> | null
  prestations: Array<Prestation>

  // Different in AuctionLine
  information: VehicleInformation
  pricing: VehiclePricing

  // Doesn't exist in AuctionLine
  auction: null | VehicleAuction
  pickupLocation: Location | null
  location: Location | null
  vendorInformation: VehicleVendorInformation | null
}

const defaultVehicle: Vehicle = {
  no: '',
  entityId: '',
  contactId: null,
  vehiclePartial: defaultVehiclePartial,
  vehicleDetail: defaultVehicleDetail,
  pickupLocation: null,
  location: null,
  vendorInformation: defaultVehicleVendorInformation,
  information: defaultVehicleInformation,
  pricing: defaultVehiclePricing,
  auction: defaultVehicleAuction,

  prestations: [],
  status: defaultStatus,
  documents: [],
  photos: [
    {
      fileStorageId: '',
      filename: '',
      doctype: null,
      attributes: null,
      url: null,
    },
  ],
}

type PaginatedVehiclesResponse = PaginatedResult<Vehicle>

export type {
  Vehicle,
  VehiclePartial,
  VehicleDetail,
  Status,
  VehicleDocument,
  Prestation,
  VehicleInformation,
  VehiclePricing,
  VehicleAuction,
  Location,
  VehicleVendorInformation,
  PaginatedVehiclesResponse,
}

export {
  defaultVehicle,
  defaultVehiclePartial,
  defaultVehicleDetail,
  defaultVehicleInformation,
  defaultVehiclePricing,
  defaultVehicleAuction,
  defaultStatus,
}
